import {Component} from "../interface/component";
import {AbstractPostListLoadMore} from "./abstract-post-list-load-more";

export class HubsComponent extends AbstractPostListLoadMore implements Component {

    private $root: JQuery;

    private $container: JQuery;

    private current_page:number;

    private max_pages:number;

    private has_more_pages:boolean = true;

    private loading:boolean = false;

    constructor(elem: HTMLElement) {
        super(elem);
        this.$root = $(elem);
        this.$container = this.$root.find('.js-hubs-container');
        this.updateDataFromDataAttributes(this.$container);
    }

    public init = () => {
        this.$load_more.on({ click: this.loadMore });
        this.handleMaxPagesReached();
    }

    private loadMore = (ev:Event) => {
        ev.preventDefault();
        if (this.has_more_pages && !this.loading) {
            let next_page = this.current_page + 1;
            this.handleLoading();
            this.loading = true;
            $.ajax({
                type: "GET",
                url: (<any>window).params.ajax_url,
                data: {
                    'action': 'fablr_get_hub_listing',
                    'paged': next_page,
                }
            }).then(
                (data:any) => {
                    let response = $(data).find('.js-articles-container');
                    let new_posts = response.children();
                    this.updateDataFromDataAttributes(response);
                    new_posts.fadeOut(0, "linear");
                    this.$container.append(new_posts);
                    this.fadeInPosts(new_posts);
                    this.handleMaxPagesReached();
                    this.loading = false;
                }
            );
        }
    }

    private handleMaxPagesReached = () => {
        this.handleLoaded(this.current_page < this.max_pages);
        this.has_more_pages = this.current_page < this.max_pages;
    }

    private fadeInPosts = ($posts: JQuery) => {
        let timeout = 0;
        let timeout_per_post = 200;
        $posts.each((index:number, element:HTMLElement) => {
            setTimeout(() => {
                $(element).fadeIn(timeout_per_post, "swing");
            }, timeout);
            timeout += timeout_per_post;
        });
    }

    private updateDataFromDataAttributes = ($element: JQuery) => {
        this.current_page = $element.data('current-page');
        this.max_pages = $element.data('max-pages');
    }
}